import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * Los parametros de caja, dentro del grupo `_direccion`.
 *
 * VA EN EL GRUPO DEL ADMINISTRADOR PORQUE LAS DOS FUNCIONES QUE LLAMA SON SUYAS y de nadie mas:
 * `app.ajustar_base_caja_noche` y `app.ajustar_fondo_fijo_caja_menor` admiten solo `administrador`.
 * La contadora tampoco las toca, asi que `_contabilidad` seria una ruta que ella puede abrir para
 * recibir un rechazo.
 *
 * ES LA PRIMERA PANTALLA DE `rpc_ajustar_fondo_fijo_caja_menor`, que existia desde la fase 4 sin
 * ninguna: la envoltura estaba escrita, probada y sin forma de llamarla desde la aplicacion.
 */
export const rutaParametrosCaja = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/parametros-caja',
  component: lazyRouteComponent(() => import('./parametros-caja-pantalla.js'), 'RutaParametrosCaja'),
});
